import { createContext, useContext, useEffect, useReducer } from 'react';
import ajaxReport from '../util/remote/ajaxReport';
import ajaxPeriod from '../util/remote/ajaxPeriod';
import functions from '../util/functions';

const initialState = { 
    weeklyIncomeGraph: null,
    monthlyIncomeGraph: null,
    financialPeriods: null,
    selectedYear: null,
    trialBalance: null,
    trialBalanceReport: null,
    incomeStatementReport: null,
    balanceSheetReport: null,
    TBDetailLevel: 0,
    ISDetailLevel: 0,
    BSDetailLevel: 0,
    mounted: false,
    ISMounted: false,
    BSMounted: false,
    dateRange: { opening_date: "", closing_date: "" }
};

const reducer = (state, action) => {

  switch (action.type) {
    case 'CLEAR':
      return { initialState};  // Reset state completely
    default:
      return {...state, [action.type]: action.payload};
  }

};


const ReportContext = createContext();

export const ReportProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(()=>{
    if(state.mounted){
      getTrialBalanceReport(true)
    }
  }, [state.TBDetailLevel])

  useEffect(()=>{
    if(state.ISMounted){
      getIncomeStatementReport(true)
    }
  }, [state.ISDetailLevel])

  useEffect(()=>{
    if(state.BSMounted){
      getBalanceSheetReport(true)
    }
  }, [state.BSDetailLevel])
  
  const getWeeklyIncomeGraph = async () => {
    const server_response  = await ajaxReport.fetchWeeklyIncomeGraph([]);
    if(server_response.status === "OK"){
        dispatch({ type: 'weeklyIncomeGraph', payload: server_response.details });
    }
  };

  const getMonthlyIncomeGraph = async () => {
    const server_response  = await ajaxReport.fetchMonthlyIncomeGraph([]);
    if(server_response.status === "OK"){
        dispatch({ type: 'monthlyIncomeGraph', payload: server_response.details });
    }
  };

  const refresh = async() =>{
    await getWeeklyIncomeGraph();
    await getMonthlyIncomeGraph();
  }

  const getFinancialPeriods = async () => {
    const server_response = await ajaxPeriod.listPeriods();
    if(server_response.status === "OK"){
      dispatch({ type: 'financialPeriods', payload: server_response.details });
    }else{
      dispatch({ type: 'financialPeriods', payload: '404' });
    }
  }

  const getTrialBalance = async () => {
    const server_response = await ajaxReport.getTrialBalance();
    if(server_response.status === "OK"){
      dispatch({ type: 'trialBalance', payload: server_response.details });
    }else{
      dispatch({ type: 'trialBalance', payload: '404' });
    }
  }

  const getTrialBalanceReport = async (refresh = false, period = null) => {
    dispatch({ type: 'mounted', payload: true });
    if(!refresh && functions.isObject(state.trialBalanceReport)){
      return;
    }

    if(refresh){
      dispatch({ type: 'trialBalanceReport', payload: null });
    }
    const server_response = await ajaxReport.fetchTrialBalanceReport({
      level: state.TBDetailLevel,
      opening_date: period?.opening_date || state.dateRange?.opening_date,
      closing_date: period?.closing_date || state.dateRange?.closing_date
    });
    if(server_response.status === "OK"){
      dispatch({ type: 'trialBalanceReport', payload: server_response.details });
    }else{
      dispatch({ type: 'trialBalanceReport', payload: '404' });
    }
  }


  const getIncomeStatementReport = async (refresh = false, period = null) => {
    dispatch({ type: 'ISMounted', payload: true });
    if(!refresh && functions.isObject(state.incomeStatementReport)){
      return;
    }

    if(refresh){
      dispatch({ type: 'incomeStatementReport', payload: null });
    }
    const server_response = await ajaxReport.fetchIncomeStatementReport({
      level: state.ISDetailLevel,
      opening_date: period?.opening_date || state.dateRange?.opening_date,
      closing_date: period?.closing_date || state.dateRange?.closing_date
    });
    if(server_response.status === "OK"){
      dispatch({ type: 'incomeStatementReport', payload: server_response.details });
    }else{
      dispatch({ type: 'incomeStatementReport', payload: '404' });
    }
  }


  const getBalanceSheetReport = async (refresh = false, period = null) => {
    dispatch({ type: 'BSMounted', payload: true });
    if(!refresh && functions.isObject(state.balanceSheetReport)){
      return;
    }

    if(refresh){
      dispatch({ type: 'balanceSheetReport', payload: null });
    }
    const server_response = await ajaxReport.fetchBalanceSheetReport({
      level: state.BSDetailLevel,
      opening_date: period?.opening_date || state.dateRange?.opening_date,
      closing_date: period?.closing_date || state.dateRange?.closing_date
    });
    if(server_response.status === "OK"){
      dispatch({ type: 'balanceSheetReport', payload: server_response.details });
    }else{
      dispatch({ type: 'balanceSheetReport', payload: '404' });
    }
  }


  
  return(
    <ReportContext.Provider value={{
      ...state, 
      dispatch, 
      getMonthlyIncomeGraph,
      getWeeklyIncomeGraph,
      getFinancialPeriods,
      getTrialBalance,
      refresh,
      getTrialBalanceReport,
      getIncomeStatementReport,
      getBalanceSheetReport
      }}>
      {children}
    </ReportContext.Provider>
  )

}

export const useReport = ()=>useContext(ReportContext);

